function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 1.619,
  width: 2.29,
  height: 21.752,
  rx: 1.145,
  transform: "rotate(-45 0 1.619)",
  fill: "#879097"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.619,
  y: 17,
  width: 2.29,
  height: 21.752,
  rx: 1.145,
  transform: "rotate(-135 1.619 17)",
  fill: "#879097"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgClose;